import React from 'react'

function PatientRescheduled() {
  return (
    <>
    test
    </>
  )
}

export default PatientRescheduled
